import Form from "@rjsf/material-ui"
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react"
import { fields } from "./fields"
import { uiSchema } from "./uiSchema"
import validator from "@rjsf/validator-ajv8"
import { widgets } from "./widgets"
import { PopupService } from "react-ui-components/components/PopupService"

// Exported for unit testing. RJSF only invokes `onError` on validation failure; previously
// that just did a `console.error`, so an invalid required field (e.g. a missing "icon") made
// Submit look completely unresponsive with zero visible feedback. See CreateEdit bug #83.
export const formatRjsfErrorSummary = (errors: any[] | undefined): string => {
  const summary = (errors || [])
    .map((error) => error?.stack || error?.message)
    .filter(Boolean)
    .join(", ")

  return summary
    ? `Please fix the highlighted fields: ${summary}`
    : "Please fix the highlighted fields before submitting."
}

const CreateEdit = ({ onSuccess, title, data, bucket, schema, imagePropName, path }: any) => {
  schema = typeof schema === "function" ? schema({ title }) : schema
  return (
    <Form
      formData={data}
      fields={fields({ bucket })}
      widgets={widgets({ bucket })}
      schema={schema}
      uiSchema={uiSchema({ bucket, propName: imagePropName })}
      validator={validator}
      // onChange={console.log('changed')}
      onSubmit={(result) => {
        onSuccess && onSuccess(result)
      }}
      onError={(errors) => PopupService.pushPopup(formatRjsfErrorSummary(errors))}
    />
  )
}

export default CreateEdit
